import { sagaEffects } from '../../dependencies';

import fetchDashboard from './fetchDashboard';

const { all } = sagaEffects;

export default function*() {
    yield all([fetchDashboard()]);
}
